import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";

export const useCrowdinTranslations = () => {
    const baseURL = process.env.CROWDIN_DISTRIBUTION_BASE_URL;
    const hash = process.env.CROWDIN_DISTRIBUTION_HASH;

    // Latest translations release timestamp
    const [timestamp, setTimestamp] = useState();
    const [translationContentPaths, setTranslationContentPaths] = useState();

    const [isInit, setIsInit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {
        // Fetch manifest
        const loadManifest = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`${baseURL}/${hash}/manifest.json`);
                const manifest = res?.data;
                setTimestamp(manifest?.timestamp);
                setTranslationContentPaths(manifest?.content);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
                setIsInit(true);
            }
        };
        loadManifest();
    }, []);

    const getTranslations = useCallback(async (locale) => {
        if (!timestamp || !translationContentPaths) {
            throw new Error("Crowdin values wrong or missing.");
        }

        try {
            const filepath = translationContentPaths?.[locale]?.[1];
            const url = `${baseURL}/${hash}${filepath}?timestamp=${timestamp}`;
            const response = await axios.get(url);

            return response?.data;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [timestamp, translationContentPaths]);

    const memoVal = useMemo(() => ({
        isInit,
        loading,
        error,
        getTranslations
    }), [
        isInit,
        loading,
        error,
        getTranslations
    ]);

    return memoVal;
};